import { useReducedMotion } from 'framer-motion';

import { cn } from '@/lib/utils';
import { brandAsset } from '@/lib/brand';

/**
 * The Clu demo loop, the one film campaign surfaces may use: it shows no
 * LinkedIn steps and no contact data. Never put `sequences-v1*.mp4` (LinkedIn
 * steps) or `people-search-demo.mp4` (old UI, contact data) on a campaign
 * surface.
 */
export const CLU_DEMO_VIDEO = '/whats-new/clu-v1-card.mp4';
export const CLU_DEMO_POSTER = brandAsset('/whats-new/clu-v1-poster.jpg');

/**
 * Muted and looping. With reduced motion it never starts by itself: it
 * waits on its poster with controls, for whoever wants to play it.
 */
export function CluDemoVideo({ className }: { className?: string }) {
  const reduceMotion = useReducedMotion() ?? false;
  return (
    <video
      src={CLU_DEMO_VIDEO}
      poster={CLU_DEMO_POSTER}
      autoPlay={!reduceMotion}
      controls={reduceMotion}
      muted
      loop
      playsInline
      preload='metadata'
      // Decorative while it plays by itself; a control once it doesn't.
      aria-hidden={reduceMotion ? undefined : true}
      className={cn(
        'aspect-video w-full rounded-xl border border-border bg-[#0c0d10] object-cover',
        className
      )}
    />
  );
}
